// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ElementController from "./element_controller"
import AsyncSelectController from "./async_select_controller"
import TooltipController from "./tooltip_controller"
import TabsController from "./tabs_controller"
import ScrollTopController from "./scroll_top_controller"
import UploadFileController from "./upload_file_controller"
import AutoSubmitController from "./auto_submit_contoller"
import AutogrowTextareaController from "./autogrow_textarea_controller"
import LinksNewTabController from "./links_new_tab_controller"
import PopupInfoController from "./popup_info_controller.js"
import TrackController from "./track_controller.js"

application.register("element", ElementController)
application.register("async-select", AsyncSelectController)
application.register("tooltip", TooltipController)
application.register("tabs", TabsController)
application.register("scroll-top", ScrollTopController)
application.register("upload-file", UploadFileController)
application.register("auto-submit", AutoSubmitController)
application.register("autogrow-textarea", AutogrowTextareaController)
application.register("links-new-tab", LinksNewTabController)
application.register("popup-info", PopupInfoController)
application.register("track", TrackController)
